// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-add-content-box {
  width: 100%;
  height: 100px;
  opacity: 1;
  font-size: 13px;
  line-height: 14px;
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 0px;
  box-sizing: border-box;
  opacity: 1;
  border-radius: 5px;
}
.voice-add-cancel {
  min-width: 60px;
  height: 26px;
  opacity: 1;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  line-height: 26px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  margin-right: 5px;
}
.voice-add-confirm {
  min-width: 64px;
  height: 30px;
  opacity: 1;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 13px;
  line-height: 30px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  float: right;
}
.voice-add-button-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.tts-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 0 6px 0;
  width: 100%;
}
.tts-player-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.tts-player-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  transition:
    background 0.2s,
    opacity 0.2s;
  opacity: 0.75;
  -webkit-user-select: none;
          user-select: none;
}
.tts-player-btn:hover {
  opacity: 1;
  background: rgba(128, 128, 128, 0.15);
}
.tts-player-btn-main {
  width: 46px;
  height: 46px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(128, 128, 128, 0.12);
}
.tts-player-btn-main:hover {
  background: rgba(128, 128, 128, 0.25);
}
.tts-player-info {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.6;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/textToSpeech/textToSpeech.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;gBAEc;EACd,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".voice-add-content-box {\n  width: 100%;\n  height: 100px;\n  opacity: 1;\n  font-size: 13px;\n  line-height: 14px;\n  padding: 5px;\n  margin-top: 10px;\n  margin-bottom: 0px;\n  box-sizing: border-box;\n  opacity: 1;\n  border-radius: 5px;\n}\n.voice-add-cancel {\n  min-width: 60px;\n  height: 26px;\n  opacity: 1;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 13px;\n  line-height: 26px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n.voice-add-confirm {\n  min-width: 64px;\n  height: 30px;\n  opacity: 1;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-size: 13px;\n  line-height: 30px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n  float: right;\n}\n.voice-add-button-container {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n.tts-player-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 14px 0 6px 0;\n  width: 100%;\n}\n.tts-player-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.tts-player-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition:\n    background 0.2s,\n    opacity 0.2s;\n  opacity: 0.75;\n  user-select: none;\n}\n.tts-player-btn:hover {\n  opacity: 1;\n  background: rgba(128, 128, 128, 0.15);\n}\n.tts-player-btn-main {\n  width: 46px;\n  height: 46px;\n  opacity: 1;\n  border-radius: 50%;\n  background: rgba(128, 128, 128, 0.12);\n}\n.tts-player-btn-main:hover {\n  background: rgba(128, 128, 128, 0.25);\n}\n.tts-player-info {\n  margin-top: 6px;\n  font-size: 12px;\n  opacity: 0.6;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
